import styled from "styled-components";

import theme from "config/theme";

import { H5 } from "components/Text";

export const Wrapper = styled.div`
  max-width: 1000px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 40px auto 20px;

  @media (max-width: ${theme.size.mobile}) {
    margin: 20px auto 0;
  }
`;

export const Item = styled.a`
  display: flex;
  align-items: flex-start;
  padding: 20px 0;
  position: relative;
  width: 40%;
  margin: 0 0 0 auto;

  &:hover {
    opacity: 0.6;
  }

  @media (max-width: ${theme.size.mobile}) {
    flex-direction: column;
    padding: 20px;
    width: 50%;
  }
`;

export const Title = styled(H5)`
  margin: -5px 0 5px;
  width: 100%;
`;

export const Text = styled.div`
  line-height: 1.5;
  color: ${theme.color.gray3};
  font-size: ${theme.font.size.epsilon};
`;
